import styles from "../../../styles/Reports.module.css";

const ReportFilterSection = ({ t, reportI18nKeys, children }) => (
  <div className={styles.filterItem}>
    <span className={styles.filterItemLabel}>
      {t(reportI18nKeys.SELECT_FILTERS_LABEL)}
    </span>
    {children}
  </div>
);

export default ReportFilterSection;
